// ============================================================
// FILE: resources/js/stores/theme.js
// USPATIH GO — Alpine Store: Theme (auto + manual)
// ============================================================

import Alpine from 'alpinejs';
import ThemeManager from '../plugins/theme.js';
import { isAutoThemeEnabled } from '../helpers/themeSchedule.js';

Alpine.store('theme', {
  auto: isAutoThemeEnabled(),
  dark: ThemeManager.isDark(),

  toggle() {
    ThemeManager.toggle();
    this.auto = ThemeManager.auto;
    this.dark = ThemeManager.isDark();
  },
});
